export default __webpack_public_path__ + "static/media/ketan.c7257c49.png";